import './navbar.less';
import template from './navbar.html';

export const navbarComponent = {
  template,
  bindings: {
    links: '<'
  }
};



/** WEBPACK FOOTER **
 ** ./client/app/shared/navbar/navbar.component.js
 **/